import { useRouter } from 'next/router'
import { getAviosBasePathEnvValue } from '@reward-platform/platform-config'
import { buildUnrestrictedRootPaths, isAuthRequiredForPath } from '~/utils/isAuthRequiredForPath'
import { useFeatureFlag } from '../featureFlag'
import { usePlatformConfig } from '../platform'

/**
 * Whether the current page requires a signed in user. withPageAuthRequired sends unauthenticated
 * users to login when it does, so other UI can use it to act only on pages browsable signed out.
 */
export const useIsAuthRequiredForPath = () => {
  const router = useRouter()
  const allowUnauthorized = useFeatureFlag('allow-unauthorized')
  const basePath = getAviosBasePathEnvValue()
  // Use the opco-validated platform locale rather than the raw router locale:
  // Next's i18n config allows any globally configured locale in the URL, but
  // not every opco enables every locale, so the server (_app.tsx) always
  // normalises to the opco-validated locale via platformConfig.locale. Using
  // the raw router locale here could disagree with the server on which paths
  // count as the unrestricted home path for a locale the current opco doesn't
  // support, reintroducing the client/server drift this shared util exists to
  // prevent.
  const { locale } = usePlatformConfig()

  const homePaths = buildUnrestrictedRootPaths(basePath, locale)
  const isEntryPoint = homePaths.includes(router.asPath)

  if (isEntryPoint && !router.query.tab) {
    return false
  }

  if (allowUnauthorized) {
    return isAuthRequiredForPath(router.asPath, homePaths)
  }

  return true
}
